/* eslint-disable import/prefer-default-export */
import { FIELD_OUTPUTS } from '../../entities/fields'
import FIELDS from './config/fields'

export function getColumnDefs ({ columns, selectGroups, formatDate = 'DD/MM/YYYY' }) {
    // Generate output field
    const createField = (type, field) => ({
        ...(FIELDS[FIELD_OUTPUTS[type]] || FIELDS.DEFAULT)({
            field, selectGroups, options: { formatDate },
        }),
        filter: false,
    })
    // Transform columns
    return columns.map((column) => {
        if (column.children) return { ...column, children: column.children.map(item => createField(item.type, item)) }
        return createField(column.type, column)
    })
}
